module.exports = __webpack_public_path__ + "img/vuetify.566547ce.svg";